import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { Plus, Trash2, ExternalLink } from 'lucide-react';

export default function Domains() {
  const [doms, setDoms] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ name: '', ipv4: '', ipv6: '', noEmail: false, noDns: false, noDnssec: false });
  const [output, setOutput] = useState(null);

  const load = () => api.get('/domains').then(r => setDoms(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    setOutput('Criando…');
    try {
      const { data } = await api.post('/domains', form);
      setOutput(data.output);
      setShow(false); setForm({ name:'', ipv4:'', ipv6:'', noEmail:false, noDns:false, noDnssec:false });
      load();
    } catch (e) { setOutput(e.response?.data?.error || 'Erro'); }
  };

  const del = async (n) => {
    if (!window.confirm(`Remover domínio ${n}?`)) return;
    await api.delete('/domains/' + n);
    load();
  };

  return (
    <>
      <div className="page-title">
        <h1>Domínios</h1>
        <button onClick={() => setShow(true)}><Plus size={14}/> Adicionar Domínio</button>
      </div>

      {output && <pre className="code" style={{marginBottom:'1rem', maxHeight:'200px', overflow:'auto'}}>{output}</pre>}

      <table>
        <thead><tr><th>Domínio</th><th>IPv4</th><th>IPv6</th><th>DNS</th><th>DNSSEC</th><th>E-mail</th><th>Webmail</th><th>Ações</th></tr></thead>
        <tbody>
          {doms.map(d => (
            <tr key={d.id}>
              <td><Link to={`/domains/${d.name}`} style={{color:'#3b82f6', textDecoration:'none', fontWeight:600}}>{d.name}</Link></td>
              <td style={{fontFamily:'JetBrains Mono'}}>{d.ipv4}</td>
              <td style={{fontFamily:'JetBrains Mono'}}>{d.ipv6}</td>
              <td>{d.has_dns ? <span className="badge ok">ok</span> : '–'}</td>
              <td>{d.has_dnssec ? <span className="badge ok">ok</span> : '–'}</td>
              <td>{d.has_email ? <span className="badge ok">ok</span> : '–'}</td>
              <td>{d.has_webmail ? <span className="badge ok">ok</span> : '–'}</td>
              <td>
                <Link to={`/domains/${d.name}`}><button className="secondary"><ExternalLink size={12}/> Abrir</button></Link>{' '}
                <button className="danger" onClick={() => del(d.name)}><Trash2 size={12}/></button>
              </td>
            </tr>
          ))}
          {doms.length === 0 && <tr><td colSpan={8} style={{textAlign:'center', color:'#a1a1aa'}}>Nenhum domínio cadastrado.</td></tr>}
        </tbody>
      </table>

      {show && (
        <div className="modal-bg" onClick={() => setShow(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>Adicionar Domínio</h2>
            <label>Nome do Domínio</label>
            <input value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="exemplo.com.br" />
            <div className="row">
              <div>
                <label>IPv4 (opcional)</label>
                <input value={form.ipv4} onChange={e => setForm({...form, ipv4: e.target.value})} placeholder="Padrão do servidor" />
              </div>
              <div>
                <label>IPv6 (opcional)</label>
                <input value={form.ipv6} onChange={e => setForm({...form, ipv6: e.target.value})} placeholder="Padrão do servidor" />
              </div>
            </div>
            <label style={{display:'flex',alignItems:'center',gap:'.5rem'}}><input type="checkbox" style={{width:'auto'}} checked={!form.noDns}    onChange={e=>setForm({...form, noDns: !e.target.checked})} /> Configurar DNS (com NS1/NS2 deste servidor)</label>
            <label style={{display:'flex',alignItems:'center',gap:'.5rem'}}><input type="checkbox" style={{width:'auto'}} checked={!form.noDnssec} onChange={e=>setForm({...form, noDnssec: !e.target.checked})} /> Ativar DNSSEC</label>
            <label style={{display:'flex',alignItems:'center',gap:'.5rem'}}><input type="checkbox" style={{width:'auto'}} checked={!form.noEmail}  onChange={e=>setForm({...form, noEmail: !e.target.checked})} /> Configurar E-mail (SMTP/IMAP/DKIM/SPF/DMARC)</label>
            <div className="modal-actions">
              <button className="secondary" onClick={() => setShow(false)}>Cancelar</button>
              <button onClick={add}>Criar</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
